import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import { BarChart } from 'echarts/charts'
import { GridComponent, LegendComponent, TitleComponent, TooltipComponent } from 'echarts/components'
import VChart from 'vue-echarts'
import { onMounted, onUnmounted, Ref, ref, watch } from 'vue'
import { getCSSVar, getLocaleString, isVisible, scrollStop } from '@/shared/helpers'
import { useRoute } from 'vue-router'
import { ECharts } from 'echarts'


export default /*#__PURE__*/_defineComponent({
  __name: 'ChartBarHor',
  props: {
	series: {
		type: Array,
		default: () => {
			return [
				{
					name: 'Пиво',
					type: 'bar',
					stack: 'total',
					color: getCSSVar('beer-color'),
					label: {
						show: true
					},
					emphasis: {
						focus: 'series'
					},
					data: [320, 302, 301, 334]
				},
				{
					name: 'Пунш',
					type: 'bar',
					stack: 'total',
					label: {
						show: true
					},
					emphasis: {
						focus: 'series'
					},
					data: [120, 132, 101, 134]
				},
				{
					name: 'Пуарэ',
					type: 'bar',
					stack: 'total',
					label: {
						show: true
					},
					emphasis: {
						focus: 'series'
					},
					data: [220, 182, 191, 234]
				},
				{
					name: 'Медовуха',
					type: 'bar',
					stack: 'total',
					label: {
						show: true
					},
					emphasis: {
						focus: 'series'
					},
					data: [150, 212, 201, 154]
				},
				{
					name: 'Прочее',
					type: 'bar',
					stack: 'total',
					color: getCSSVar('secondary-color'),
					label: {
						show: true
					},
					emphasis: {
						focus: 'series'
					},
					data: [506, 408, 550, 590]
				}
			]
		}
	},
	instantInit: {
		type: Boolean,
		default() {
			return false
		}
	},
	stackMode: {
		type: Boolean,
		default() {
			return true
		}
	},
	action3nd: {
		type: String,
		default: ''
	}
},
  setup(__props) {

const props = __props;

use([
	CanvasRenderer,
	BarChart,
	TitleComponent,
	TooltipComponent,
	LegendComponent,
	GridComponent
])



const route = useRoute()

const chartWrapper = ref(null)
const chart: Ref<ECharts> = ref(null)
const option = ref(null)

const toggleView = (isStack) => {
	const series = chart.value.getOption().series

	if (isStack) {
		series.map(item => item.stack = 'total')
	} else {
		series.map(item => item.stack = '')
	}

	chart.value.setOption({
		series: series
	})
}

const currentYear = new Date().getFullYear().toString()
const previousMonth = new Date().getMonth().toString()
const yearFromRoute = route.params.year.toString()

const defaultPeriod = () => {
	let result: string

	if (currentYear === yearFromRoute) {
		result = `01.${currentYear} - ${
			previousMonth.length > 1
				? previousMonth
				: '0' + previousMonth}.${currentYear
		}`
	} else {
		result = '2023'
	}

	return result
}

const chartInit = () => {
	const selectedYear = route.params.year
	let years = ['2018', '2019', '2020', '2021', '2022', defaultPeriod()]
	const data = []

	const countOfYearsIncludesData = props.series[0].data.length

	if (years.length > countOfYearsIncludesData) {
		years = years.slice(countOfYearsIncludesData, years.length)
	}

	years.forEach(year => {
		if (year.includes(selectedYear?.toString())) {
			data.push({
				value: year,
				textStyle: {
					color: '#fff',
					fontWeight: 'bold',
					fontSize: 16,
					backgroundColor: getCSSVar('primary-color'),
					padding: 6
				}
			})
		} else {
			data.push(year)
		}
	})
	if (props.instantInit || (isVisible(chartWrapper.value) && !option.value)) {
		option.value = {
			tooltip: {
				trigger: 'item',
				axisPointer: {
					// Use axis to trigger tooltip
					type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
				},
				formatter(params) {
					return `
            <div class="report-tooltip">
              <div class="report-tooltip__title">${params.seriesName}: </div>
              <span class="report-tooltip__text">
              	${formatData(params.value)}
              </span>
              тыс. декалитров (дал) <br>
              <span class="report-tooltip__text">
									${(+params.value / +params.data.total * 100).toFixed(1)}%
									</span> в общем объеме ${props.action3nd}
              <div>за ${params.name} год</div>
            </div>
          `
				}
			},
			legend: {
				show: true,
				textStyle: {
					fontSize: 14
				},
				top: 235
			},
			grid: {
				left: '20%',
				right: '20%',
				bottom: '20%',
				top: '3%',
				containLabel: true
			},
			xAxis: {
				type: 'value',
				axisLabel: {
					formatter: function(value) {
						return getLocaleString(value)
					}
				}
			},
			yAxis: {
				type: 'category',
				data: data
			},
			series: props.series
		}
	}
}

const formatData = (data: number) => {
	return getLocaleString((data / 1000).toFixed(1))
}

watch(() => props.stackMode, () => {
	toggleView(props.stackMode)
})

onMounted(() => {
	scrollStop(chartInit)

	chartInit()
})


onUnmounted(() => {
	if (chart.value) chart.value?.clear()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "chartWrapper",
    ref: chartWrapper,
    class: "chart-wrapper"
  }, [
    _createVNode(_unref(VChart), {
      class: "chart",
      ref_key: "chart",
      ref: chart,
      option: option.value
    }, null, 8, ["option"])
  ], 512))
}
}

})